import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../css/loyaltystats.css";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const LoyaltyStats = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [customer, setCustomer] = useState(null);
  const [history, setHistory] = useState([]);



  useEffect(() => {
    const fetchData = async () => {
      try {
        const custRes = await fetch(`https://pos-backend-58o9.onrender.com/api/customers/${id}`);
        const custData = await custRes.json();
        setCustomer(custData);

        const pointRes = await fetch(`https://pos-backend-58o9.onrender.com/api/loyalty/history/${id}`);
        const pointData = await pointRes.json();
        setHistory(pointData || []);
      } catch (err) {
        console.error("Failed to fetch loyalty details:", err);
      }
    };

    fetchData();
  }, [id]);


// ✅ Filter active-only entries
const activeHistory = history.filter((h) => h.status === "active");

// 🧮 Compute totals based on active entries only
const totalEarned = activeHistory.reduce((sum, h) => sum + (h.points_earned || 0), 0);
const totalRedeemed = activeHistory.reduce((sum, h) => sum + (h.points_redeemed || 0), 0);


  const chartData = [
    {
      label: "Points",
      earned: totalEarned,
      redeemed: totalRedeemed
    }
  ];
  
  return (
    <div className="loyalty-history-container">
      <div className="loyalty-history-header">
        <h2>Points History for {customer?.name}</h2>
        <p>Phone: {customer?.phone || customer?.contact || "-"}</p>
        <button onClick={() => navigate("/loyalty")}>← Back to Loyalty Overview</button>
      </div>


      {/* ✅ Chart Section */}
      <div className="loyalty-chart">
        <h4>Points Summary</h4>
        <ResponsiveContainer width="100%" height={300}>
        <BarChart data={chartData}>
  <CartesianGrid strokeDasharray="3 3" />
  <XAxis dataKey="label" />
  <YAxis allowDecimals={false} />
  <Tooltip />
  <Legend />
  <Bar dataKey="earned" name="Points Earned" fill="#26A69A" />
  <Bar dataKey="redeemed" name="Points Redeemed" fill="#FF7043" />
</BarChart>

        </ResponsiveContainer>
      </div>


      <table className="loyalty-history-table">
        
        <thead>
          <tr>
            <th>Date</th>
            <th>Type</th>
            <th>Points</th>
            <th>Receipt No</th>
          </tr>
        </thead>
        <tbody>
          {history.length > 0 ? (
            history.map((entry, index) => (
              <tr key={index}>
                <td>{new Date(entry.created_at).toLocaleString()}</td>
                <td>{entry.transaction_type}</td>
                <td>{entry.points_earned || entry.points_redeemed}</td>
                <td>{entry.receipt_no}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" style={{ textAlign: "center" }}>No points history found.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default LoyaltyStats;
